import { useState } from "react";
import {
  Paper,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import Loading from "../ui/Loading";
import InvoicesDetailModal from "./InvoicesDetailModal";

const YtdInvoicingCard = ({
  data,
  isLoading,
  error,
  filters,
  invoicesDetail,
  getInvoices,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  if (isLoading) return <Loading />;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!data || data.length === 0)
    return <Typography>No YTD invoicing data available</Typography>;

  const totalInvoiceAmount = data.reduce(
    (sum, item) => sum + (item.invoiceTotal || 0),
    0,
  );
  const totalInvoiceCount = data.reduce(
    (sum, item) => sum + (item.invoiceCount || 0),
    0,
  );

  const handleRowClick = (client) => {
    setSelectedClient(client);
    setShowModal(true);
  };

  return (
    <>
      <Paper sx={{ p: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6">
            Year-to-Date Invoicing ({filters.year})
          </Typography>
          <Box sx={{ textAlign: "right" }}>
            <Typography
              variant="h5"
              color="primary"
              sx={{ fontWeight: "bold" }}
            >
              ${totalInvoiceAmount.toLocaleString()}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
            >
              {totalInvoiceCount} invoices
            </Typography>
          </Box>
        </Box>

        <TableContainer sx={{ maxHeight: 400 }}>
          <Table
            stickyHeader
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCell>Client</TableCell>
                <TableCell align="right">Invoice Count</TableCell>
                <TableCell align="right">Total Amount</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow
                  key={index}
                  hover
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell>{row.clientName || "Unknown"}</TableCell>
                  <TableCell align="right">{row.invoiceCount || 0}</TableCell>
                  <TableCell align="right">
                    ${(row.invoiceTotal || 0).toLocaleString()}
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      size="small"
                      variant="text"
                      onClick={() => handleRowClick(row)}
                    >
                      View Details
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {showModal && selectedClient && (
        <InvoicesDetailModal
          open={showModal}
          onClose={() => {
            setShowModal(false);
            setSelectedClient(null);
          }}
          filters={filters}
          clientId={selectedClient.clientId}
          clientName={selectedClient.clientName}
          invoicesDetail={invoicesDetail}
          getInvoices={getInvoices}
        />
      )}
    </>
  );
};

export default YtdInvoicingCard;
